(ns pfo.widget.pdf (:require [cljs-uuid-utils.core :as uuid]
                             [pfo.util :as util]
                             [ajax.protocols :as protocol]
                             [dommy.core :as dommy :refer-macros [sel sel1]]
                             [ajax.core :as ajax]
                             [promesa.core :as p]
                             [reagent.core :as r]))

;; pdfjs comes from the webpack bundle (client/index.js), not a string require:
;; shadow-cljs cannot process pdf.mjs. See the comment there for why.
;; Read lazily, never at namespace load: admin/base.html loads app.js without
;; index_bundle.js, so the global does not exist on those pages.
(defn- pdfjs [] js/pdfjsLib)

;; The global Promise is bluebird - measured in the running page as 3.7.2, even
;; though promesa calls Promise.noConflict() (promesa/impl.cljc:47). It has no
;; withResolvers, and its try spreads an array second argument where pdfjs passes
;; (fn, ...args). The bundle's core-js polyfills cannot cover this: they patched
;; the Promise that was global when index_bundle.js loaded, and app.js replaced it.
;; Takes the constructor to patch so a test can hand it a stand-in: the karma
;; page's global is the native Promise, which needs none of this and would let
;; the whole function be deleted with every test still green.
(defn ensure-promise-compat!
  ([] (ensure-promise-compat! js/Promise))
  ([P]
   (when-not (fn? (.-withResolvers P))
     (set! (.-withResolvers P)
           (fn []
             (let [out #js {}]
               (set! (.-promise out)
                     (P. (fn [resolve reject]
                           (set! (.-resolve out) resolve)
                           (set! (.-reject out) reject))))
               out))))
   ;; Only bluebird's is replaced; a native one already behaves correctly. attempt
   ;; is bluebird's alias of the same function, so it is kept identical rather than
   ;; left pointing at the old one. Nothing in this app calls either.
   (when (.-version P)
     (let [std-try (fn [f & args]
                     (P. (fn [resolve reject]
                           (try
                             (resolve (apply f args))
                             (catch :default e (reject e))))))]
       (set! (.-try P) std-try)
       (set! (.-attempt P) std-try)))))

(defn- init-pdfjs! []
  (ensure-promise-compat!)
  (set! (-> (pdfjs) .-GlobalWorkerOptions .-workerSrc) "/static/lib/js/pdf.worker.mjs"))

;; From pdfjs 3 on these are separate downloads rather than worker built-ins, and
;; each is silently skipped when its URL is unset: wasmUrl serves the JBIG2 and
;; JPEG2000 decoders (plus their JS fallbacks), so scans using those codecs do not
;; render without it; standardFontDataUrl is consulted only for Symbol and
;; ZapfDingbats - the AcroForm checkbox glyphs - since everything else falls back
;; to system fonts. Callers pass a URL string or a params object; normalize both.
;;
;; The defaults come first, so a caller that sets one of these keys itself
;; overrides the default rather than losing its value to it.
(defn doc-params [source]
  (js/Object.assign #js {:wasmUrl "/static/lib/pdfjs/wasm/"
                         :iccUrl "/static/lib/pdfjs/iccs/"
                         :standardFontDataUrl "/static/lib/pdfjs/standard_fonts/"}
                    (if (string? source) #js {:url source} source)))

(defn pdf-view [{:keys [pdf-location multi-page placeholder on-click rendered-cb load-pdf on-error
                        current-page-atom num-pages-atom hide-nav]}]
  (init-pdfjs!)
  (let [id (uuid/make-random-uuid)
        canvas-id (str "pdf-canvas-" id)
        wrapper-id (str "pdf-canvas-wrapper-" id)
        pdf-doc (atom nil)
        ;; num-pages / current-page may be supplied by the host so it can render
        ;; the pager elsewhere (e.g. the staging review workspace shows it in its
        ;; own header and passes :hide-nav to suppress the built-in one). When not
        ;; supplied, pdf-view owns them and renders its own pager.
        num-pages (or num-pages-atom (r/atom nil))
        max-height (atom 0)
        page (atom nil)
        current-page (or current-page-atom (r/atom 1))
        rendering-in-progress (atom false)
        page-num-pending (atom nil)
        default-load-pdf (fn []
                           (ajax/POST (:url pdf-location)
                             {:params {:key (:key pdf-location) :pdf "1"}
                              :format :url
                              :response-format {:content-type "application/pdf"
                                                :description "pdf"
                                                :read protocol/-body
                                                :type :arraybuffer}
                              :handler (fn [response]
                                         (-> (pdfjs)
                                           (.getDocument (doc-params #js {:data response}))
                                           .-promise
                                           (.then (fn [pdf]
                                                    (reset! pdf-doc pdf)
                                                    (reset! num-pages (aget pdf "numPages"))))
                                           (.catch (fn [err] (prn err)))))}))
        load-page (fn load-page [page-num]
                    (when @pdf-doc 
                      (if @rendering-in-progress
                        (reset! page-num-pending page-num)
                        (let [canvas (.getElementById js/document canvas-id)
                              container (.getElementById js/document wrapper-id)]
                          (reset! rendering-in-progress true)
                          (reset! current-page page-num)
                          (set! (.-width canvas) (.-clientWidth container))
                          (-> (.getPage @pdf-doc @current-page)
                            (.then (fn [page]
                                     (let [scale #js{:scale 1.0}
                                           canvas (.getElementById js/document canvas-id)
                                           viewport (.getViewport page #js{:scale (/ (.-width canvas) (.-width (.getViewport page scale)))})
                                           context (.getContext canvas "2d")
                                           render-context #js {"canvasContext" context
                                                               "viewport" viewport}]
                                       (.log js/console canvas)
                                       (swap! max-height max (.-height viewport))
                                       (.log js/console (.getViewport page scale))
                                       (set! (.-height canvas) @max-height)
                                       (-> (.render page render-context)
                                         (.-promise)
                                         (.then (fn []
                                                  (reset! rendering-in-progress false)
                                                  (some-> rendered-cb (apply []))
                                                  (when-let [new-page-num @page-num-pending]
                                                    (reset! page-num-pending nil)
                                                    (load-page new-page-num))))
                                         (.catch (fn [err] (prn err)))))))
                            (.catch (fn [err] (prn err))))))))]
    (if load-pdf
      (load-pdf (fn [response]
                  (-> (pdfjs)
                    (.getDocument (doc-params response))
                    .-promise
                    (.then (fn [pdf]
                             (reset! pdf-doc pdf)
                             (reset! num-pages (aget pdf "numPages"))))
                    ;; On a PDF load failure: if the caller provided :on-error
                    ;; let it handle the failure (e.g. show a fallback) and do
                    ;; NOT reload. Otherwise keep the legacy retry-by-reload used
                    ;; by the Dropbox Sign signed-document view, where the signed
                    ;; PDF may not be ready immediately after signing.
                    (.catch (fn [err]
                              (if on-error
                                (on-error err)
                                (js/setTimeout #(js/window.location.reload) 10000)))))))
      (default-load-pdf))
    
    (r/create-class
      {:component-did-update #(load-page @current-page) 
       :reagent-render (fn []
                         [:div.pdf-view  {:id wrapper-id}
                          ;; Deref both page atoms during render so host-driven
                          ;; page changes (when :hide-nav is set and the pager
                          ;; lives in the host's header) re-render this component →
                          ;; component-did-update → load-page. The built-in pager
                          ;; renders only when :hide-nav is not set.
                          (let [page-count  @num-pages
                                page-number @current-page]
                            (cond
                              (nil? page-count)
                              (if placeholder [placeholder] [:div "Please wait..."])

                              (and multi-page (not hide-nav))
                              [:p.nav
                               [:button
                                {:on-click (util/handler
                                             (fn [] (when (> page-number 1)
                                                      (load-page (dec page-number)))))}
                                "<"]
                               " " page-number "/" page-count " "
                               [:button
                                {:on-click (util/handler
                                             (fn [] (when (< page-number page-count)
                                                      (load-page (inc page-number)))))}
                                ">"]]

                              :else nil))

                          [:canvas (merge {:id canvas-id} (if on-click {:on-click on-click} {}))]])})))
